import { render } from "./applyMy.vue?vue&type=template&id=64bdf350&scoped=true"
import script from "./applyMy.vue?vue&type=script&lang=js"
export * from "./applyMy.vue?vue&type=script&lang=js"

import "./applyMy.vue?vue&type=style&index=0&id=64bdf350&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bdf350"]])

export default __exports__